import { ServerFetch } from '../main-model'

export default class ShortcutProductModel extends ServerFetch {
    getShortcutProductBy = (data) => this.authFetch({
        url: 'shortcut-product/getShortcutProductBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}